import type { ComponentType, FC, SVGProps } from 'react';

import Select from '@/components/elements/forms/Select';
import { APPOINTMENT_STATUS_ACTIVE, APPOINTMENT_STATUS_CANCELLED } from '@/constants/appointmentConstants';
import { _s } from '@/locale';

import { BsCircle as BsCircleRaw, BsFunnel as BsFunnelRaw, BsRecordCircle as BsRecordCircleRaw } from 'react-icons/bs';
import { components } from 'react-select';

const RecordIcon = BsRecordCircleRaw as unknown as React.ComponentType<any>;
const CircleIcon = BsRecordCircleRaw as unknown as React.ComponentType<any>;
const FunnelIcon = BsRecordCircleRaw as unknown as React.ComponentType<any>;

const { Option, Control } = components;

const BsRecordCircleIcon = BsRecordCircleRaw as ComponentType<SVGProps<SVGSVGElement>>;
const BsCircleIcon = BsCircleRaw as ComponentType<SVGProps<SVGSVGElement>>;
const BsFunnelIcon = BsFunnelRaw as ComponentType<SVGProps<SVGSVGElement>>;

const SelectedIcon: FC = () => (
  <BsRecordCircleIcon
    style={{
      marginRight: 7,
      fontSize: '18px',
      color: '#23a994',
      display: 'inline-block',
      height: 20,
    }}
  />
);

const DefaultIcon: FC = () => (
  <BsCircleIcon
    style={{
      marginRight: 7,
      display: 'inline-block',
      fontSize: '18px',
    }}
  />
);

const FilterIcon: FC = () => <BsFunnelIcon style={{ marginLeft: 10 }} />;

const IconOption = (props: any) => {
  const { isSelected } = props;
  return (
    <Option {...props}>
      {isSelected ? <SelectedIcon /> : <DefaultIcon />}
      {props.data.label}
    </Option>
  );
};

type BookingFilterProps = {
  onChange: any;
  value: any;
};

export const filterOptions = [
  {
    value: '',
    label: _s('viewAllBookings'),
    trackingValue: 'all',
  },
  {
    value: APPOINTMENT_STATUS_ACTIVE,
    label: _s('viewAllBookingsActive'),
    trackingValue: 'active',
  },
  {
    value: APPOINTMENT_STATUS_CANCELLED,
    label: _s('viewAllBookingsCanceled'),
    trackingValue: 'canceled',
  },
];

const customStyles = {
  control: (styles) => ({
    ...styles,
    borderColor: '#23a994',
    borderRadius: 7,
    cursor: 'pointer',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#23a994',
    },
    '&:focus': {
      borderColor: '#23a994',
    },
  }),
  option: (styles) => {
    return {
      ...styles,
      backgroundColor: '#FFF',
      color: '#000',
      cursor: 'pointer',
      ':active': {
        backgroundColor: '#FFF',
      },
    };
  },
};

const BookingFilter: FC<BookingFilterProps> = (props) => {
  return (
    <Select
      {...props}
      options={filterOptions}
      styles={customStyles}
      components={{
        Option: IconOption,
        Control: ({ children, ...controlProps }) => (
          <Control {...controlProps}>
            <FilterIcon />
            {children}
          </Control>
        ),
      }}
    />
  );
};

export default BookingFilter;
